import React, { useEffect } from 'react';
import { useState } from 'react';
import HelpDialog from './HelpDialog';
import HelpUtil, { HelpKey } from '../../util/HelpUtil';
import { HelpData, HelpInfo } from '../../autogenerated/ZoomBridge';
import GetHelpQuery from '../../queries/help/GetHelpQuery';
import ErrorId from '../../protocol/ErrorId';
import t, { i18nHas } from '../../i18n/I18n';

/**
 * 
 * @param {{helpKey: HelpKey}} param0 
 * @returns a functional HelpIcon Component which is to rendered at any place.
 */
function HelpWrapper({ helpKey, onClose }) {
  const [helpData, setHelpData] = useState(undefined);
  const [childHelpInfo, setChildHelpInfo] = useState(undefined);

  useEffect(() => {
    console.log("Help QUery triggered")
    let mounted: boolean = true;
    let query = new GetHelpQuery(helpKey);
    query.run().then(
      (helpResp: HelpData) => {
        if (mounted) {
          if (HelpUtil.isHelpDataNotEmpty(helpResp)) {
            setHelpData(helpResp);
          }
          else {
            let error = t('HELP_KEY_NOT_FOUND_ERROR');
            window.setError(error);
          }
        }
      },
      (helpError: ErrorId) => {
        if (mounted) {
          let error = helpError ? helpError.toString() : t('UNKNOWN_HELP_ERROR');
          window.setError(error);
        }
      }
    )
    return () => {
      mounted = false;
    };
  }, [helpKey]);

  const onCloseHelpDialog = (e) => {
    setChildHelpInfo(undefined);
    setHelpData(undefined);
    onClose(e);
  };

  const onTextTypeChildClick = (childHelpInfo) => {
    setChildHelpInfo(childHelpInfo);
  };

  const onCloseChildDialog = () => {
    setChildHelpInfo(undefined);
  };

  return (
    <div name="Help-Wrapper" className='help-wrapper'>
      {
        HelpUtil.isHelpDataNotEmpty(helpData) ?
          (
            <HelpDialog helpInfo={helpData.getHelpInfo()} helpItems={helpData.getHelpItems()}
              onCloseDialog={onCloseHelpDialog} onChildItemClick={onTextTypeChildClick} />
          ) : null
      }
      {
        HelpUtil.isHelpInfoNotEmpty(childHelpInfo) ?
          (
            <HelpDialog helpInfo={childHelpInfo} onCloseDialog={onCloseChildDialog} />
          ) : null
      }
    </div>
  );
}

export default HelpWrapper;
